import { render, staticRenderFns } from "./registro_proveedor_exito.vue?vue&type=template&id=f5bc696a&scoped=true"
import script from "./registro_proveedor_exito.vue?vue&type=script&lang=js"
export * from "./registro_proveedor_exito.vue?vue&type=script&lang=js"
import style0 from "./registro_proveedor_exito.vue?vue&type=style&index=0&id=f5bc696a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5bc696a",
  null
  
)

export default component.exports